import { el } from "@dhx/ts-common/dom";
import { getCount, getIcon, getNavbarButtonCSS } from "./helpers";

export function button(item: any, widgetName: string) {
	const getAriaAttrs = item => {
		const isItemActivated = item.active || item.$activeParent;
		const attrs = {
			"aria-disabled": item.disabled ? "true" : "false",
			"aria-label": item.value || item.tooltip || item.id || "" + ` ${item.count || ""}`,
		};

		if (item.items) {
			// as menu
			attrs["id"] = item.id;
			attrs["aria-haspopup"] = "menu"; // menu has hot keys, listbox doesn't have

			if (isItemActivated) {
				attrs["aria-expanded"] = "true";
			}
		}

		return attrs;
	};
	const isIconButton = item.icon && !item.value;
	const counterClass = isIconButton ? " dhx_navbar-count--absolute" : " dhx_navbar-count--button-inline";
	return el(
		"button.dhx_button",
		{
			class: getNavbarButtonCSS(item, widgetName),
			dhx_id: item.id,
			disabled: item.disabled,
			type: "button",
			...getAriaAttrs(item),
		},
		[
			item.icon ? getIcon(item.icon, "button") : null,
			item.html
				? el("div.dhx_button__text", { ".innerHTML": item.html })
				: item.value && el("span.dhx_button__text", item.value),
			item.count > 0 && getCount(item, counterClass, isIconButton),
			item.value && item.$openIcon
				? el("span.dhx_button__icon.dhx_button__icon--menu.dxi.dxi-menu-right", {
						"aria-hidden": "true",
				  })
				: null,
			item.loading &&
				el(
					"span.dhx_button__loading",
					{
						"aria-hidden": "true",
					},
					[el("span.dhx_button__loading-icon.dxi.dxi-loading")]
				),
		]
	);
}
